export default __webpack_public_path__ + "static/twister-049eb4ed837042bb30c2e905f753096a.png";